import { getTryCounts, getCsInfo, readOrder } from '@/api/pay'

const Pay = {
  namespaced: true,

  state: {
    countLimit: {
      // 是否会员
      is_member: true,
      // 剩余对话次数
      over_count: 5,
      // 对话总次数
      total_count: 5,
      // 剩余创建智能体次数
      over_create_assistant_count: 1,
      // 创建智能体总次数
      create_assistant_total_count: 1
    },
    csInfo: {
      unread_num: 0,
      submit_url: '',
      detail_url: '',
      success_order_num: 0
    }
  },
  mutations: {
    SET_COUNT_LIMIT: (state, val) => {
      state.countLimit = val
    },
    SET_CS_INFO: (state, val) => {
      state.csInfo = val || {}
    }
  },
  actions: {
    GetTryCounts({ commit, rootState }) {
      const isVip = rootState.Home.userInfo?.member_info?.member_status === 2
      if (isVip) return
      return new Promise((resolve, reject) => {
        getTryCounts()
          .then(res => {
            if (res.status === 0) {
              commit('SET_COUNT_LIMIT', res.result)
              resolve()
            }
          })
          .catch(err => {
            console.log(err)
            reject(err)
          })
      })
    },
    GetCsInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getCsInfo()
          .then(res => {
            if (res.status === 0) {
              commit('SET_CS_INFO', res.result)
              resolve(res)
            }
          })
          .catch(err => {
            console.log(err)
            reject(err)
          })
      })
    },
    ReadOrder({ dispatch }, payload) {
      return new Promise((resolve, reject) => {
        readOrder(payload)
          .then(res => {
            if (res.status === 0) {
              resolve()
            }
          })
          .catch(err => {
            console.log(err)
            reject(err)
          })
      })
    }
  }
}

export default Pay
